const PARROT_ACADEMY_BASE_URL = `${process.env.REACT_APP_PARROT_ACADEMY_BASE_URL}/reportes-pa`;

export const REPORT_ACADEMY_LINKS = {
  SALES: `${PARROT_ACADEMY_BASE_URL}/reporte-de-ventas-v2`,
  PAYMENTS: `${PARROT_ACADEMY_BASE_URL}/reporte-de-pagos-v2`,
  PRODUCTS: `${PARROT_ACADEMY_BASE_URL}/reporte-de-articulos`,
  CANCELLATION: `${PARROT_ACADEMY_BASE_URL}/reporte-de-cancelaciones-v2`,
} as const;
